module.exports = __webpack_public_path__ + "static/media/ils_esign_success_myway.715818c1.svg";